import React from 'react'

import apiMethodStyles from "./ApiMethod.module.css"

export default function ApiMethod({ children, title }) {
    return(       
        <span className={apiMethodStyles.container}>
            {children}
            <span className={apiMethodStyles.marker}>api</span>
        </span>
    )
}